import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../stores/auth.store";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";

type AdminLayoutProps = {
  children: ReactNode;
};

export function AdminLayout({ children }: AdminLayoutProps) {
  const { user, isLoading, isSystemAdmin } = useAuthStore();

  // ローディング中
  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
          <p className="mt-4 text-gray-600">読み込み中...</p>
        </div>
      </div>
    );
  }

  // 未ログイン
  if (!user) {
    return <Navigate replace to="/admin/login" />;
  }

  // システム管理者でない
  if (!isSystemAdmin) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-100">
        <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-md">
          <h1 className="mb-4 font-bold text-red-600 text-xl">アクセス権限がありません</h1>
          <p className="mb-6 text-gray-600">
            このページにアクセスするにはシステム管理者権限が必要です。
          </p>
          <p className="text-gray-500 text-sm">ログイン中: {user.email}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Sidebar />
      <Header />
      <main className="ml-64 pt-16">
        <div className="p-6">{children}</div>
      </main>
    </div>
  );
}
